import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"3\" height=\"2\" fill=\"#2B2B2B\" opacity=\".5\" rx=\"1\"></rect><rect width=\"14\" height=\"2\" x=\"5\" fill=\"#2B2B2B\" opacity=\".5\" rx=\"1\"></rect><rect width=\"3\" height=\"2\" y=\"6\" fill=\"#2B2B2B\" opacity=\".5\" rx=\"1\"></rect><rect width=\"14\" height=\"2\" x=\"5\" y=\"6\" fill=\"#2B2B2B\" opacity=\".5\" rx=\"1\"></rect><rect width=\"3\" height=\"2\" y=\"12\" fill=\"#2B2B2B\" opacity=\".5\" rx=\"1\"></rect><rect width=\"14\" height=\"2\" x=\"5\" y=\"12\" fill=\"#2B2B2B\" opacity=\".5\" rx=\"1\"></rect>", 6)
  ])))
}
export default { render: render }